import React from 'react';
import { useLocation } from 'react-router-dom';
import RailSubmenu from './RailSubmenu';
import { SLOT_TABS, slotTabFrom, slotTabPath } from '../lib/slotTabs';

// Sol raydaki "Slotlar" maddesinin alt menüsü (Betrun). Alt maddeler slot
// sayfasının vitrin sekmeleridir (Tümü hariç — onu ana madde zaten açar);
// Canlı Casino'nun masa alt menüsüyle aynı kalıp.
const SUB_ITEMS = SLOT_TABS.filter((t) => t.id !== 'all');

const RailSlotSubmenu = ({ prefix, children, onNavigate }) => {
  const location = useLocation();
  const currentTab = location.pathname === '/slotlar'
    ? slotTabFrom(location.search)
    : null;
  return (
    <RailSubmenu
      prefix={prefix}
      onNavigate={onNavigate}
      items={SUB_ITEMS}
      currentId={currentTab}
      pathFor={slotTabPath}
      storageKey="rail:slot-sub-open"
      groupLabel="Slot sekmeleri"
      showLabel="Slot sekmelerini göster"
      hideLabel="Slot sekmelerini gizle"
    >
      {children}
    </RailSubmenu>
  );
};

export default RailSlotSubmenu;
